import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { useCart } from '@/contexts/CartContext';
import { ClipboardList } from 'lucide-react';

interface CartButtonProps {
  variant?: 'default' | 'outline' | 'ghost';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  showCount?: boolean;
  className?: string;
}

const CartButton = ({ 
  variant = 'outline', 
  size = 'sm', 
  showCount = true,
  className = '' 
}: CartButtonProps) => {
  const { cartCount, setIsCartOpen } = useCart();
  const ariaLabel = cartCount > 0
    ? `View registration cart (${cartCount} item${cartCount === 1 ? '' : 's'})`
    : 'View registration cart (empty)';

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant={variant}
          size={size}
          onClick={() => setIsCartOpen(true)}
          aria-label={ariaLabel}
          className={`relative ${className}`}
        >
          <ClipboardList className="h-4 w-4" aria-hidden="true" />
          {cartCount > 0 && (
            <span className="absolute -top-1 -right-1 h-2.5 w-2.5 rounded-full bg-primary animate-pulse" />
          )}
          {size !== 'icon' && <span className="ml-2 hidden sm:inline">Cart</span>}
          <span className="sr-only">{ariaLabel}</span>
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        {cartCount > 0 ? `View pending registrations (${cartCount})` : 'Registration cart is empty'}
      </TooltipContent>
    </Tooltip>
  );
};

export default CartButton;
